import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { cardHoverBoxShadow } from 'approot/shared/styles/cards.style';
import { grey1, grey9 } from 'approot/shared/styles/colours.style';
import { baseBoxShadowFocus } from 'approot/shared/styles/borders.style';
import {
  spacing8,
  spacing12,
  spacing16,
} from 'approot/shared/styles/spacing.style';
import { fontSize16 } from 'approot/shared/styles/typography.style';

export const SimpleCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SimpleCardButton = styled.button`
  background: transparent;
  border: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  width: 100%;

  &:hover {
    cursor: pointer;
  }

  &:focus {
    color: inherit;
    outline: none;
  }

  &:hover + div {
    box-shadow: ${cardHoverBoxShadow};
  }

  &:focus + div {
    border: 1px solid ${grey1};
    box-shadow: ${baseBoxShadowFocus};
  }

  &:hover:focus + div {
    box-shadow: ${baseBoxShadowFocus}, ${cardHoverBoxShadow};
  }
`;

export const SimpleCardBox = styled.div`
  display: block;
  position: relative;
  height: 100%;
`;

export const SimpleCardActions = styled.div`
  display: flex;
  gap: ${rem(spacing8)};
  padding: ${rem(spacing16)};
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
`;

export const SimpleCardTitle = styled.div`
  color: ${grey9};
  font-size: ${rem(fontSize16)};
  margin-top: ${rem(spacing12)};
`;

export const SimpleCardInner = styled.div``;
